export default __webpack_public_path__ + "static/media/pets_allowed.9f5ffef2.svg";